import React from 'react';

import Button from '../../../button/button';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import { RIDE_HEIGHT_TYPES } from '../../../../shared/constants/fitment';

import './fitment-optional-size-buttons.scss';

interface FitmentOptionalSizeProps {
  children?: React.ReactNode;
  className?: string;
  isViewDisabled?: boolean;
  onReturnClick: () => void;
  onViewClick: () => void;
  returnLabel?: string;
  selectedRideHeight?: {
    type?: string;
  };
  showReturnButton?: boolean;
  showViewButton?: boolean;
}

function FitmentOptionalSizeButtons(props: FitmentOptionalSizeProps) {
  const {
    children,
    className = '',
    isViewDisabled = false,
    onReturnClick,
    onViewClick,
    returnLabel = 'return to original tire sizes',
    selectedRideHeight,
    showReturnButton,
    showViewButton
  } = props;

  const getViewOptionalSizesLabel = (rideHeightType?: string) => {
    switch (rideHeightType) {
      case RIDE_HEIGHT_TYPES.LIFTED:
        return 'View Optional Lifted Sizes';
      case RIDE_HEIGHT_TYPES.LOWERED:
        return 'View Optional Lowered Sizes';
      default:
        return 'View Optional Sizes';
    }
  };

  function getRideHeightEventName(type) {
    switch (type) {
      case RIDE_HEIGHT_TYPES.LIFTED:
        return 'vehicle_click_opt_tire_size_lifted';
      case RIDE_HEIGHT_TYPES.LOWERED:
        return 'vehicle_click_opt_tire_size_lowered';
      case RIDE_HEIGHT_TYPES.STOCKHEIGHT:
        return 'vehicle_click_opt_tire_size';
    }
  }

  const viewLabel = getViewOptionalSizesLabel(selectedRideHeight?.type);

  return (
    <div className={className} styleName="container">
      {showViewButton && (
        <Button
          isDisabled={isViewDisabled}
          isSecondary
          onClick={() => {
            const eventName = getRideHeightEventName(selectedRideHeight?.type);
            if (eventName) {
              trackAction(eventName);
            }
            onViewClick();
          }}
        >
          {viewLabel}
        </Button>
      )}

      {children}

      {showReturnButton && (
        <Button
          onClick={() => {
            trackAction('vehicle_click_return_from_opt_sizes');

            onReturnClick();
          }}
          styleName="return-button"
        >
          {returnLabel}
        </Button>
      )}
    </div>
  );
}

export default FitmentOptionalSizeButtons;
